// SafetyMenu.js
// Holding all the buttons for the Safety Forms.

import React from "react";
import { useAppStore } from "../../../../store/appStore";
import { useUserState } from "../../../../context/user";
import styles from "./SafetyMenu.module.css";

const SafetyMenuOptions = ({
  activeTab,
  isSafetyFormsMenuExpanded,
  onTabClick,
}) => {
  const user = useUserState().currentUser;
  const toggleSafetyFormsMenu = useAppStore(
    (s) => s.mainMenuActions.toggleSafetyFormsMenu
  );

  // Making the forms hide and show the table if the submenu is clicked.
  const setShowNearMissForm = useAppStore(
    (s) => s.safetyPageActions.setShowNearMissForm
  );
  const setShowSafetyAuditForm = useAppStore(
    (s) => s.safetyPageActions.setShowSafetyAuditForm
  );

  // Check if user has access to reporting (safety team member or access level >= 2)
  const hasReportingAccess =
    user &&
    (user.safety_team_member === 1 || user.access_level >= 2);

  // Function to handle submenu option clicks
  const handleSubmenuClick = (tabName) => {
    onTabClick(tabName);
    if (tabName === "nearMiss") {
      setShowNearMissForm(false);
      // } else if (tabName === "safetyAudit") {
      //   setShowSafetyAuditForm(false);
      // } else {
      //   setShowNearMissForm(false);
      //   setShowSafetyAuditForm(false);
    }

    // Close the submenu on mobile and tablet screens
    if (window.innerWidth < 1024) {
      toggleSafetyFormsMenu();
    }
  };

  return (
    <div
      className={`${styles.safetyFormsMenuContainer} ${
        isSafetyFormsMenuExpanded ? styles.expanded : ""
      }`}
      data-testid="safety-forms-menu-options"
    >
      <button
        className={`${styles.tabButton} ${
          activeTab === "nearMiss" ? styles.active : ""
        }`}
        onClick={() => handleSubmenuClick("nearMiss")}
        data-testid="near-miss-tab"
      >
        Near Miss
      </button>
      <button
        className={`${styles.tabButton} ${
          activeTab === "safetyAudit" ? styles.active : ""
        }`}
        onClick={() => handleSubmenuClick("safetyAudit")}
        data-testid="safety-audit-tab"
      >
        Safety Audit
      </button>
      <button
        className={`${styles.tabButton} ${
          activeTab === "sdsLookup" ? styles.active : ""
        }`}
        onClick={() => handleSubmenuClick("sdsLookup")}
        data-testid="sds-lookup-tab"
      >
        SDS Lookup
      </button>
      {/* Desktop-only Safety Form Reporting - Access controlled */}
      {window.innerWidth >= 1024 && hasReportingAccess && (
        <button
          className={`${styles.tabButton} ${
            activeTab === "safetyFormReporting" ? styles.active : ""
          } ${styles.desktopOnly}`}
          onClick={() => handleSubmenuClick("safetyFormReporting")}
          data-testid="safety-form-reporting-tab"
        >
          All Safety Forms
        </button>
      )}
      {/* <button
        className={`${styles.tabButton} ${
          activeTab === "incidentInvestigation" ? styles.active : ""
        }`}
        onClick={() => handleSubmenuClick("incidentInvestigation")}
        data-testid="incident-investigation-tab"
      >
        Incident Investigation
      </button> */}
    </div>
  );
};

export const SafetyMenu = ({
  activeTab,
  isSafetyFormsMenuExpanded,
  mainMenuStyles,
  handleMainMenuButtonClick,
  onTabClick,
}) => {
  // Check if any Safety Forms tab is active
  const isAnySafetyFormsTabActive =
    activeTab === "nearMiss" ||
    activeTab === "safetyAudit" ||
    activeTab === "safetyFormReporting" ||
    activeTab === "incidentInvestigation" ||
    activeTab === "sdsLookup";

  return (
    <>
      <button
        className={`${mainMenuStyles.tabButton} ${styles.safetyFormsButton} ${
          isAnySafetyFormsTabActive ? styles.active : ""
        }`}
        onClick={() => handleMainMenuButtonClick("safetyForms")}
        data-testid="safety-forms-menu-button"
      >
        Safety Forms {isSafetyFormsMenuExpanded ? "▼" : "▶"}
      </button>
      <SafetyMenuOptions
        activeTab={activeTab}
        isSafetyFormsMenuExpanded={isSafetyFormsMenuExpanded}
        onTabClick={onTabClick}
      />
    </>
  );
};
